import React from "react";
import { useTranslation } from "@lib/i18n";

import Typography from "@components/shared/Typography";

import { openDocument } from "@lib/openDocument";
import gtm from "@gtm/core";
import { compareEquipmentsClickEvent } from "@gtm/events/homepage";
import { useGetAssetPath } from "hooks/useGetAssetPath";
import { withTabNavigation } from "@hoc/withTabNavigation";
import { PDF_DOCUMENT_TYPES } from "@shared/constants";

const TypographyWithTabNavigation = withTabNavigation(Typography);

const CompareButtonContainer = () => {
  const { t, i18n } = useTranslation();
  const getAssetPath = useGetAssetPath(i18n.language);

  const containsTranslation =
    !!t("compareButtonContainer.compare") &&
    !!t("compareButtonContainer.preconfigurations");

  if (!containsTranslation) return <div className="h-4" />;

  const clickOpenDocument = () => {
    gtm.fire(
      compareEquipmentsClickEvent({
        label: `${t("compareButtonContainer.compare")} ${t(
          "compareButtonContainer.preconfigurations"
        )}`,
      })
    );

    openDocument(
      getAssetPath(PDF_DOCUMENT_TYPES.COMPARISON_OF_PRECONFIGURATIONS)
    );
  };

  return (
    <div className="text-center my-4 lg:m-auto lg:ml-2 lg:min-w-32 lg:text-left">
      <TypographyWithTabNavigation
        className="flex justify-center relative text-sm text-white uppercase cursor-pointer lg:text-xs hover:font-extrabold"
        onClick={clickOpenDocument}
      >
        <span className="inline border-b border-b-white w-fit my-4">
          {t("compareButtonContainer.compare") +
            t("compareButtonContainer.preconfigurations")}
        </span>
      </TypographyWithTabNavigation>
    </div>
  );
};

export default CompareButtonContainer;
